import React from 'react';
import { motion } from 'framer-motion';
import { CheckIcon, XIcon } from 'lucide-react';
const forWho = ['Parejas en EE.UU. que llevan más de 6 meses buscando el positivo sin éxito.', 'Personas con "infertilidad inexplicada" que quieren soluciones reales y tangibles.'];
const notForWho = ['Quienes buscan una pastilla mágica y no están dispuestos a cambiar un solo producto en su hogar.'];
export function ForWhom() {
  return <section className="w-full bg-beige py-20 md:py-28" data-id="element-104">
      <div className="max-w-5xl mx-auto px-6 md:px-8" data-id="element-105">
        <div className="grid md:grid-cols-2 gap-6 md:gap-8" data-id="element-106">
          <motion.div initial={{
          opacity: 0,
          x: -20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6,
          ease: 'easeOut'
        }} className="bg-sage-soft rounded-2xl p-8 md:p-10 border border-sage/40" data-id="element-107">
            <span className="inline-block bg-white text-sage-ink text-xs font-semibold tracking-widest uppercase px-3 py-1 rounded-full mb-4" data-id="element-108">
              Para ti, si...
            </span>
            <h2 className="font-serif text-2xl md:text-3xl text-ink mb-6" data-id="element-109">
              Para quién es esto
            </h2>
            <div className="space-y-4" data-id="element-110">
              {forWho.map((item, index) => <div key={index} className="flex gap-3" data-id="element-111">
                  <div className="flex-shrink-0 inline-flex items-center justify-center w-7 h-7 rounded-full bg-sage-deep mt-0.5" data-id="element-112">
                    <CheckIcon className="w-4 h-4 text-white" data-id="element-113" />
                  </div>
                  <p className="text-ink-soft leading-relaxed" data-id="element-114">{item}</p>
                </div>)}
            </div>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          x: 20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6,
          ease: 'easeOut'
        }} className="bg-blush-soft rounded-2xl p-8 md:p-10 border border-blush/40" data-id="element-115">
            <span className="inline-block bg-white text-blush-ink text-xs font-semibold tracking-widest uppercase px-3 py-1 rounded-full mb-4" data-id="element-116">
              No es para ti, si...
            </span>
            <h2 className="font-serif text-2xl md:text-3xl text-ink mb-6" data-id="element-117">
              Para quién NO es esto
            </h2>
            <div className="space-y-4" data-id="element-118">
              {notForWho.map((item, index) => <div key={index} className="flex gap-3" data-id="element-119">
                  <div className="flex-shrink-0 inline-flex items-center justify-center w-7 h-7 rounded-full bg-blush-deep mt-0.5" data-id="element-120">
                    <XIcon className="w-4 h-4 text-white" data-id="element-121" />
                  </div>
                  <p className="text-ink-soft leading-relaxed" data-id="element-122">{item}</p>
                </div>)}
            </div>
          </motion.div>
        </div>
      </div>
    </section>;
}